// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-1235d7db] button{font-weight:700}* input[data-v-1235d7db],* select[data-v-1235d7db],*[data-v-1235d7db] button{font-family:Open Sans,sans-serif!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
